import React from "react";
import Nav from "@/components/eilea/Nav";
import Hero from "@/components/eilea/Hero";
import Problem from "@/components/eilea/Problem";
import HowItWorks from "@/components/eilea/HowItWorks";
import Benefits from "@/components/eilea/Benefits";
import Result from "@/components/eilea/Result";
import Lookbook from "@/components/eilea/Lookbook";
import Ingredients from "@/components/eilea/Ingredients";
import Waitlist from "@/components/eilea/Waitlist";
import Footer from "@/components/eilea/Footer";

export default function Landing() {
  return (
    <main className="bg-[#FDFBF7] text-[#2C2826] selection:bg-[#2C2826] selection:text-[#FDFBF7]">
      <Nav />
      <Hero />
      <Problem />
      <HowItWorks />
      <Benefits />
      <Result />
      <Lookbook />
      <Ingredients />
      <Waitlist />
      <Footer />
    </main>
  );
}
